import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'app/service/storage.service';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Token } from "../dto/token.dto";
import { Usuario } from '../dto/usuario.dto';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private usuario: Token = null;
  isExpired = new Subject<boolean>();
  constructor(
    private router: Router,
    private http: HttpClient,
    private storageService: StorageService,
  ) { }

  getUsuario(): Token {
    return this.storageService.getItem('user') ? JSON.parse(this.storageService.getItem('user')) : null;
  }

  isAuthenticated(): boolean {
    return this.getUsuario() !== null && this.getUsuario() !== undefined;
  }

  login(userName: string, password: string, rememberMe: boolean): Observable<Token> {
    return this.http.post<Token>(environment.url_backend + 'usuario/login', { "email": userName, "password": password }).pipe(
      map(user => {
        console.log("---> ", user);
        // TODO ver estos dos datos donde se ponen
        user.usuario = userName;
        user.img = 'assets/images/logoWhite.svg';
        if (user && user.token) {
          if(rememberMe){
            this.storageService.setItem('userName', userName);
            this.storageService.setItem('password', password);
            this.storageService.setItem('rememberMe', 'true');
          }else{
            this.storageService.removeItem('userName');
            this.storageService.removeItem('password');
            this.storageService.removeItem('rememberMe');
          }
          this.storageService.setItem('user', JSON.stringify(user));
          this.usuario = user;
        }
        this.setIntervalCheckToken(user.tokenExpiresIn);
        return user;
      }));
  }

  async logout(): Promise<void> {
    this.usuario = null;
    this.storageService.removeItem('user');
    this.router.navigate(['auth', 'login']);
  }
  
  handleNewToken(token: Token) {
    this.usuario = this.getUsuario();
    this.usuario.token = token.token;
    this.usuario.tokenExpiresIn = token.tokenExpiresIn;
    this.storageService.setItem('user', JSON.stringify(this.usuario));
    this.isExpired.next(false);
    this.setIntervalCheckToken(this.usuario.tokenExpiresIn).then();
  }

  resetPass(hash: string, password: string): Observable<Usuario> {
    var usuario = { password: password, hash: hash };
    return this.http.post<Usuario>(environment.url_backend + 'usuario/reestablecerClave', usuario);
  }

  requestPass(email: string): Observable<void> {
    var usuario = { email: email };
    return this.http.post<void>(environment.url_backend + 'usuario/codigoReestablecerClave', usuario);
  }

  validateHash(hash: string): Observable<void> {
    var usuario = { hash: hash };
    return this.http.post<void>(environment.url_backend + 'usuario/validarCodigoReestablecerClave', usuario);
  }
  getusuarios(): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(environment.url_backend + 'usuario');
  }

  /* Renovar sesión */

  checkSessionTimeOut() {
    this.isExpired.next(true);
  }

  async setIntervalCheckToken(tokenExpiresIn) {
    console.log("----> ", tokenExpiresIn);
    console.log("----> ", tokenExpiresIn - 60000);
    let tiempoSesion = tokenExpiresIn - 60000; 
    const interval = setInterval(() => {
      this.checkSessionTimeOut();
      if (this.isExpired) {
        clearInterval(interval);
      }
    }, tiempoSesion);
  }

  async refreshToken() {
    this.http.post<Token>(environment.url_backend + "usuario/renovar-token", { token: this.usuario.token }).toPromise().then(
      data => {
        this.usuario.token = data.token;
        this.usuario.tokenExpiresIn = data.tokenExpiresIn;
        this.storageService.setItem('user', JSON.stringify(this.usuario));
        this.isExpired.next(false);
        this.setIntervalCheckToken(this.usuario.tokenExpiresIn).then();
      }
    );
  }

}
